import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "./Auth";
import { db } from "./base";
import { NavLink } from "react-router-dom";
import {
  faFilePdf,
  faClipboardList,
  faFileCode,
  faNetworkWired,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Nav from "./nav";

const Home = () => {
  const { currentUser } = useContext(AuthContext);
  const [user, setUser] = useState("");

  useEffect(() => {
    if (currentUser !== null) {
      db.collection("users")
        .doc(currentUser.uid)
        .get()
        .then((doc) => {
          setUser(doc.data().role);
        });
    }
  }, []);

  return (
    <>
      <Nav />
      <div className="menu-home">
        <div className="links">
          {user === "admin" && (
            <>
              <h1>Admin</h1>
              <NavLink to="/fichiers-pdf-site-internet" activeClassName="active">
                <FontAwesomeIcon icon={faNetworkWired} />
                <span>Admin PDF Site Internet</span>
              </NavLink>
              <NavLink to="/fichiers-produits-clients" activeClassName="active">
                <FontAwesomeIcon icon={faFileCode} />
                <span>Admin Produits Clients</span>
              </NavLink>
              <NavLink to="/fichiers-catalogues-clients" activeClassName="active">
                <FontAwesomeIcon icon={faFilePdf} />
                <span>Admin Catalogues Clients</span>
              </NavLink>
              <h1 className="title_2">Clients</h1>
            </>
          )}
          <NavLink to="/liste-produits" activeClassName="active">
            <FontAwesomeIcon icon={faClipboardList} />
            <span>Liste produits / stocks</span>
          </NavLink>
          <NavLink to="/liste-catalogues" activeClassName="active">
            <FontAwesomeIcon icon={faClipboardList} />
            <span>Liste Catalogues</span>
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Home;
